<!-- 旧件回收订单详情页 -->
<template>
  <div class="app-container order-detail-wrap">
    <div class="module-wrap">
      <el-descriptions title="基础信息" class="common-description-border">
        <el-descriptions-item label="订单编号">{{ formData.recycleNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ formData.recycleStatus | changeStatus(BusinessRecycleStatusEnum) }}</el-descriptions-item>
        <!-- // 新增项目编号 -->
        <el-descriptions-item label="项目编号">{{ formData.projectNo || '--' }}</el-descriptions-item>
        <!-- // 新增项目名称 -->
        <el-descriptions-item label="项目名称">{{ formData.projectName || '--' }}</el-descriptions-item>
        <!-- // 新增下单旧机 -->
        <el-descriptions-item label="下单旧机">{{ formData.orderCount || '--' }}</el-descriptions-item>
        <el-descriptions-item label="承运商">{{ formData.carrierName || '--' }}</el-descriptions-item>
        <!-- // 新增承运商组织 -->
        <el-descriptions-item label="承运商组织">{{ formData.carrierOrg || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收地址"
          >{{ completeAddress || '--' }}
          <span v-if="completeAddress">
            <img v-if="!dataVisible.address" src="@/assets/eye-close.png" @click="toggleVisibility('address')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('address')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="联系人">{{ formData.contactName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话"
          >{{ formData.contactMobile || '--' }}
          <span v-if="formData.contactMobile">
            <img v-if="!dataVisible.contactMobile" src="@/assets/eye-close.png" @click="toggleVisibility('contactMobile')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('contactMobile')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="期望回收日期">{{ formData.expectRecycleDate || '--' }} </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formData.createdDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <!-- 回收人员就是回收师傅 -->
      <el-descriptions title="派工信息">
        <el-descriptions-item label="回收人员姓名">{{ formData.recoveryWorkerName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收人员电话"
          >{{ formData.recoveryWorkerMobile || '--' }}
          <span v-if="formData.recoveryWorkerMobile">
            <img v-if="!dataVisible.recoveryWorkerMobile" src="@/assets/eye-close.png" @click="toggleVisibility('recoveryWorkerMobile')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('recoveryWorkerMobile')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="取货车牌号">{{ formData.vehicleLicenseNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="预约时间">{{ transDateTimeStrFun() }}</el-descriptions-item>
        <el-descriptions-item label="完成预约时间">{{ formData.completedAppointDate || '--' }}</el-descriptions-item>
        <el-descriptions-item label="派车时间">{{ formData.dispatchDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
        <el-descriptions-item label="完成时间">{{ formData.completedDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
        <el-descriptions-item label="异常信息反馈">{{ formData.feedback || '--' }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <el-descriptions title="回收信息" class="common-description-border">
        <el-descriptions-item label="签到时间">{{ formData.signInDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
        <el-descriptions-item label="签到地址"
          >{{ formData.signInAddress || '--' }}
          <span v-if="formData.signInAddress">
            <img v-if="!dataVisible.signInAddress" src="@/assets/eye-close.png" @click="toggleVisibility('signInAddress')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('signInAddress')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="实收旧机">{{ formData.actualCount || '--' }}</el-descriptions-item>

        <el-descriptions-item label="交割单照片">
          <template v-if="formData.waybillPhoto">
            <div class="downLoadLink" v-if="isPDF(formData.waybillPhoto)" @click="downLoadPdf(formData.waybillPhoto)">
              {{ formData.waybillPhoto }}
            </div>
            <image-upload v-else :imageUrl.sync="formData.waybillPhoto" :editMode="true" @success="uploadSuccess($event, 'waybillPhoto')" />
          </template>
          <span v-else>--</span>
        </el-descriptions-item>
        <el-descriptions-item label="装车照片">
          <image-upload v-if="formData.cargoLoadingPhoto" :imageUrl.sync="formData.cargoLoadingPhoto" :editMode="true" @success="uploadSuccess($event, 'cargoLoadingPhoto')" />
          <span v-else>--</span>
        </el-descriptions-item>
        <el-descriptions-item
          label="备注"
          :contentStyle="{
            display: '-webkit-box', // 添加此行
            'white-space': 'pre-wrap',
            'word-break': ' break-all',
            '-webkit-line-clamp': 3,
            '-webkit-box-orient': 'vertical', // 添加此行
            overflow: 'hidden',
            'text-overflow': 'ellipsis'
          }"
          >{{ formData.remark || '--' }}</el-descriptions-item
        >
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <div class="sub-title">回收明细</div>
      <div class="table">
        <el-table :data="listData">
          <el-table-column label="操作" fixed="left" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="showDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          <!-- 保留项目明细行号 -->
          <el-table-column prop="projectDetailNo" label="项目明细行号"></el-table-column>
          <!-- 保留旧机品牌 -->
          <el-table-column prop="brandName" label="旧机品牌"></el-table-column>
          <!-- 保留旧机类型 -->
          <el-table-column prop="category" label="旧机类型"></el-table-column>
          <!-- 保留旧机系列 -->
          <el-table-column prop="specification" label="旧机系列"></el-table-column>
          <!-- 保留冷量 -->
          <el-table-column prop="coolNum" label="冷量"></el-table-column>
          <!-- 保留年限 -->
          <el-table-column prop="useAge" label="年限"></el-table-column>
          <!-- 保留是否拆机 -->
          <el-table-column prop="disassembled" label="是否拆机">
            <template slot-scope="scope">
              {{ scope.row.disassemble | BooleanStatus }}
            </template>
          </el-table-column>
          <!-- 保留条码 -->
          <el-table-column prop="barCode" label="条码"></el-table-column>
        </el-table>
      </div>
    </div>

    <searchOldDetailDialog ref="detailDialogRef"></searchOldDetailDialog>
  </div>
</template>
<script>
import { getRecoveryOrderByOrderNo, updateOldMachineRecovery } from '@/api/COldForNew'
import { orderStatusOption } from './mixin.js'
import imageUpload from '@/components/Upload/ImageUpload'
import searchOldDetailDialog from './components/searchOldDetailDialog' //旧机信息详情
import enumMixin from './enumMixin.js'

export default {
  name: 'orderDetail',
  components: { imageUpload, searchOldDetailDialog },
  computed: {
    baseUrl() {
      return process.env.BASE_API
    },
    // 回收地址
    completeAddress() {
      const { province, city, county, address } = this.formData
      return `${province}${city}${county}${address}`
    }
  },
  mixins: [enumMixin],
  data() {
    return {
      recycleNo: this.$route.query.recycleNo,
      formData: {
        status: '1',
        outBoundPhoto: '', //出库
        loadTruckPhoto: ''
      }, //回收详情对象
      listData: [], //回收详情明细
      productImageBase64: '',
      orderStatusOption: orderStatusOption, //订单状态
      partnershipType: '', // 1: "子公司", 2: "合作商", 3: "总公司" ,
      originData: {},
      recoveryWorkerMobile:'',
      contactMobile:'',
      address:'',
      signInAddress:'',
      dataVisible: {
        recoveryWorkerMobile: false,
        contactMobile: false,
        address: false,
        signInAddress: false
      }
    }
  },
  filters: {
    changeStatus(value, orderStatusOption) {
      if (value) {
        const statusOption = orderStatusOption.find(item => item.enumCode == value)
        return statusOption ? statusOption.description : '--'
      }
    },
    BooleanStatus(value) {
      if (value === 0) return '否'
      if (value === 1) return '是'
      return '--'
    }
  },
  async created() {
    this.partnershipType = JSON.parse(localStorage.getItem('partnershipType'))
    if (this.recycleNo) {
      this.getDetail()
    }
  },
  methods: {
    formatImgUrl(value) {
      return this.baseUrl + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${value}`
    },
    //获取回收详情
    async getDetail() {
      let { statusCode, data, message } = await getRecoveryOrderByOrderNo(this.recycleNo)
      if (statusCode == 200) {
        this.formData = data.oldMachineRecycle
        this.originData = data.oldMachineRecycle ? { ...data.oldMachineRecycle } : {}
        this.listData = data.recycleProjectList || []

        // 根据 sensitizationCode 拆分数据
        if (data.desensitizationDtoList && Array.isArray(data.desensitizationDtoList)) {
          const dataMappings = {
            recoveryWorkerMobile_phone: 'recoveryWorkerMobile',
            contactMobile_phone: 'contactMobile',
            address_address: 'address',
            signInAddress_address: 'signInAddress'
          }

          data.desensitizationDtoList.forEach(item => {
            const targetProperty = dataMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
      } else {
        this.$message.error(message)
      }
    },
    async uploadSuccess(val, flag) {
      this.formData[flag] = val
      const param = {
        recycleNo: this.formData.recycleNo,
        fileId: val,
        annexType: flag === 'waybillPhoto' ? 1 : 2
      }
      const { statusCode } = await updateOldMachineRecovery(param)
      if (statusCode == 200) {
        this.$message.success('更新图片成功')
      }
    },
    async changeStatus(val) {
      const statusOption = this.orderStatusOption.find(item => item.value === val)
      return statusOption ? statusOption.label : ''
    },
    //网点旧机规格格式化
    formatOldType({ brand, specification, model }) {
      return (brand ? brand : '') + (specification ? specification : '') + (model ? model : '')
    },
    //回收人员旧机规格格式化

    formatAppraisalOldType({ appraisalBrand, appraisalSpecification, appraisalModel }) {
      return (
        (appraisalBrand ? (appraisalBrand == 'GREE' ? '格力' : '非格力') : '') + (appraisalSpecification ? appraisalSpecification : '') + (appraisalModel ? appraisalModel : '')
      )
    },
    isPDF(url) {
      return url.endsWith('.pdf')
    },
    downLoadPdf(url) {
      const pdfUrl = process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${url}`

      window.open(pdfUrl, '_blank')
    },
    //查看回收明细的详情

    showDetail(row) {
      if (row.id) {
        this.$refs.detailDialogRef.openDialog(row.id)
      }
    },
    transDateTimeStrFun() {
      const { appointBeginDate = '', appointEndDate = '' } = this.formData
      if (appointBeginDate && appointBeginDate != 'null' && appointEndDate && appointEndDate != 'null') {
        return `${appointBeginDate}~${appointEndDate}`
      }
      return appointBeginDate || appointEndDate || '--'
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'recoveryWorkerMobile':
          if (this.dataVisible.recoveryWorkerMobile && this.recoveryWorkerMobile.message) {
            this.getSourceOrigin(this.recoveryWorkerMobile).then(res => {
              this.$set(this.formData, 'recoveryWorkerMobile', res)
            })
          } else if (!this.dataVisible.recoveryWorkerMobile) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'recoveryWorkerMobile', this.originData.recoveryWorkerMobile)
          }
          break
        case 'contactMobile':
          if (this.dataVisible.contactMobile && this.contactMobile.message) {
            this.getSourceOrigin(this.contactMobile).then(res => {
              this.$set(this.formData, 'contactMobile', res)
            })
          } else if (!this.dataVisible.contactMobile) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'contactMobile', this.originData.contactMobile)
          }
          break
        case 'address':
          if (this.dataVisible.address && this.address.message) {
            this.getSourceOrigin(this.address).then(res => {
              this.$set(this.formData, 'address', res)
            })
          } else if (!this.dataVisible.address) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'address', this.originData.address)
          }
          break
          case 'signInAddress':
          if (this.dataVisible.signInAddress && this.signInAddress.message) {
            this.getSourceOrigin(this.signInAddress).then(res => {
              this.$set(this.formData, 'signInAddress', res)
            })
          } else if (!this.dataVisible.signInAddress) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'signInAddress', this.originData.signInAddress)
          }
          break
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.order-detail-wrap {
  .module-wrap {
    margin-bottom: 10px;
  }
  .sub-title {
    font-size: 16px;
    font-weight: bold;
    color: rgb(48, 49, 51);
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .total-price {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
  }
  .footer-wrap {
    display: flex;
    justify-content: flex-end;
  }
  .downLoadLink {
    color: #1459c0;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/COldForNewService/orderDetail.vue